/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
export var euiPageHeaderStyles = function euiPageHeaderStyles(_ref) {
  var euiTheme = _ref.euiTheme;
  return {
    euiPageHeader: /*#__PURE__*/css(logicalCSS('width', '100%'), ";", logicalCSS('min-width', '0'), ";display:flex;flex-direction:column;flex-shrink:0;;label:euiPageHeader;"),
    border: /*#__PURE__*/css(logicalCSS('border-bottom', euiTheme.border.thin), ";;label:border;")
  };
};